import {GET_MAX_NUMBER_OF_LOAN_PAYMENTS} from "../actions/loan/loanRetailerPropertyAction";

export const maxNumberOfLoanPayments = (state = {}, action) => {
    switch (action.type) {
        case GET_MAX_NUMBER_OF_LOAN_PAYMENTS:
            return {
                ...state,
                maxNumberOfPayments: action.maxNumberOfPayments
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/loanRetailerProperty.js